import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 链动 #10027
export default [{
  path: "/consumptionDividend",
  component: function component() {
    return import("../../../views/extension/consumption_dividend/index.vue");
  },
  name: "consumptionDividend",
  meta: {
    title: "消费分红",
    foot: true
  }
}];